import React, {Component} from 'react';
import couterpart from 'counterpart';

import MenuComponent2 from './MenuComponent2';
import ItemDataService from '../services/ItemDataService';
import ItemImageList from './ItemImageList';

import '../css/style.css';
import { ICON_BACK } from '../icon';

class ItemDetailsView extends Component {
    constructor() {
        super();
        this.state = {
            item: {},
            itemId: 0,
            updated: false,
            images: []
        } 
    };

    componentDidMount () {
        const { id } = this.props.match.params;
        ItemDataService.retrieveById(`${id}`).then(data => {
          this.setState({ item:  data, itemId:  id}, ()=>{
            ItemDataService.retrieveImagesOfItem(this.state.item.id).then(data => {
                this.setState({ images:  data});
            });
          })
        });
    }

    backToList(){
        this.props.history.push("/items");
    }

    render() {
        const item_name = couterpart.translate('item_name');
        const item_sku = couterpart.translate('item_sku');
        const item_color = couterpart.translate('item_color');
        const item_design = couterpart.translate('item_design');
        const item_size = couterpart.translate('item_size');
        const item_options = couterpart.translate('item_options');
        const button_back = couterpart.translate('button_back');

        return (
            <div>
                <MenuComponent2/>
                <div style={{padding:"5px"}}>
                <button class="myButton" onClick={this.backToList.bind(this)}>
                        <img alt={button_back} src={ICON_BACK}/>&nbsp;{button_back}&nbsp;&nbsp;&nbsp;&nbsp;</button>
                </div>
                <table width="100%" border="1">
                    <tbody>                       
                    <tr>
                        <td><label>*{item_name}</label></td>
                        <td><input name="name" 
                            type="text" defaultValue={this.state.item.name}/></td>
                    </tr>
                    <tr>
                        <td><label>*{item_sku}</label></td>
                        <td><input name="sku" type="text" 
                            defaultValue={this.state.item.sku}/></td>
                    </tr>                                               
                    <tr>
                        <td><label>{item_color}</label></td>
                        <td><input name="colorMaterial"  type="text" 
                            defaultValue={this.state.item.colorMaterial}/></td>
                    </tr> 
                    <tr>
                        <td><label>{item_design}</label></td>
                        <td><input name="shapeDesign"  type="text" 
                            defaultValue={this.state.item.shapeDesign}/></td>
                    </tr>
                    <tr>
                        <td><label>{item_size}</label></td>
                        <td><input name="lengthSize"  type="text" 
                            defaultValue={this.state.item.lengthSize}/></td>
                    </tr>
                    <tr>
                        <td><label>{item_options}</label></td>
                        <td><input name="otherSubOptions"  type="text" 
                            defaultValue={this.state.item.otherSubOptions}/></td>
                    </tr>                                                                                                                       
                    <tr>
                        <td colSpan = "2">
                        <ItemImageList images={this.state.images}/>
                        </td>
                    </tr>                        
                    </tbody>
                </table>                    
            </div>
        );
    }
}

export default ItemDetailsView;